import _ from "lodash";
import React, { useEffect, useState, useContext } from "react";
// react-bootstrap components
import { Card, Container, Row, Col } from "react-bootstrap";
import { apiService } from "../../../service/ApiService";
import { notificationService } from "../../../service/NotificationService";
import { exportToExcel } from "utils/AppUtils";
import CreateTableBtn from "components/Buttons/CreateTableBtn";
import StoreContext from "contexts/StoreContext";
import HippoTable from "components/ReactTable/HipposReactTable";
import StatusColumn from "components/Custom/StatusColumn";
import FreePriceColumn from "components/Custom/FreePriceColumn";
import ColorColumn from "components/Custom/ColorColumn";
import TimestampColumn from "components/Custom/TimestampColumn";
import EditButton from "views/Components/EditButton";
import ShowModalButton from "views/Components/ShowModalButton";
import PricelistsPriceModal from "components/Modals/PricelistsPriceModal";
import ExportToExcelButton from "views/Components/ExportToExcelButton";
import ImportCsvButton from "views/Components/ImportCsvButton";
import ImportCsvModal from "components/Modals/ImportCsvModal";
import moment from "moment";
import ProductInventoryModal from "components/Modals/ProductInventoryModal";
import { ClipLoader } from "react-spinners";

import { useTranslation } from "react-i18next";

function ProductListPage() {
  const {
    t,
  } = useTranslation();

  const [data, setData] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const { storeId, setStoreId } = useContext(StoreContext);
  const [alert, setAlert] = useState(null);
  let [openModal, setOpenModal] = useState(0);
  let [openInventoryModal, setOpenInventoryModal] = useState(0);
  const [productId, setProductId] = useState(null);
  const [productName, setProductName] = useState(null);
  const [excelLoading, setExcelLoading] = useState(false);
  const [product, setProduct] = useState(null);
  const [forceUpdate, setForceUpdate] = useState(0);
  const [showLoader, setShowLoader] = useState(true);
  const [showImport, setShowImport] = useState(false);

  const showModal = (el) => {
    setProductId(el.id);
    setProductName(el.name);
    setOpenModal(++openModal);
  };

  const showInventoryModal = (el) => {
    setProduct(el);
    setOpenInventoryModal(++openInventoryModal);
  };

  const columns = [
    {
      Header: "ID",
      accessor: "id",
      maxWidth: 60,
      minWidth: 40,
      width: 60,
    },
    {
      Header: t("tables.headers.description"),
      accessor: "name",
      minWidth: 200,
      maxWidth: 350,
      width: 200,
    },
    {
      Header: t("tables.headers.price"),
      accessor: "price",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.category"),
      accessor: "category",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.stock"),
      accessor: "inventory",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.status"),
      accessor: "status",
      minWidth: 80,
      maxWidth: 100,
      width: 80,
    },
    {
      Header: "BARCODE",
      accessor: "barcode",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.actions"),
      accessor: "edit",
      minWidth: 200,
      maxWidth: 200,
      width: 200,
    },
  ];

  const fetchData = async () => {
    setShowLoader(true);
    try {
      const dataResponse = await apiService.get(`api/v1/products/store/${storeId}`);
      setData(attachCustom(dataResponse));
    } catch (error) {
      console.error("Error fetching data:", error);
      notificationService.notifyWarn(error.message);
    } finally {
      setShowLoader(false);
    }
  };

  const updateTable = () => {
    setForceUpdate(+Date.now());
  };

  const attachCustom = (data) => {
    const enhanced = data.map((el) => {
      el.status = <StatusColumn value={el.deleted} />;
      el.freePrice = <FreePriceColumn value={el.freePrice} />;
      el.weighed = <FreePriceColumn value={el.weighed} />;
      el.colorComponent = <ColorColumn color={el.color} />;
      el.timestamp = <TimestampColumn timestamp={el.updatedAt} />;
      el.edit = (
        <div>
          <ShowModalButton handler={() => showInventoryModal(el)} variant="info" icon="fa fa-plus" className="text-success btn-link" title={t("common.actions.addStock")} />
          <ShowModalButton handler={() => showModal(el)} variant="success" icon="fa fa-euro-sign" className="text-danger btn-link" title={t("common.actions.editPrices")} />
          <EditButton uri={`/admin/product/${el.id}`} />
        </div>
      );
      el.price = el.price.toFixed(2);
      el.category = el.category.name;
      return el;
    });
    return _.sortBy(enhanced, ["order", "id"]);
  };

  const formatData = (data) => {
    const formattedData = data.map((product) => {
      return {
        ID: product.id,
        [t("tables.headers.description")]: product.name,
        [t("tables.headers.documentText")]: product.documentName,
        [t("tables.headers.priceEuro")]: product.price.toFixed(2),
        [t("tables.headers.vat")]: product.vat.percent,
        [t("tables.headers.vatExemptionCategory")]: product.vatExemptionCategory ? product.vatExemptionCategory.description : null,
        [t("tables.headers.category")]: product.category.name,
        [t("tables.headers.type")]: product.productType.description,
        [t("tables.headers.position")]: product.order,
        [t("tables.headers.stock")]: product.inventory,
        [t("tables.headers.updatedAt")]: moment(product.updatedAt).format("DD/MM/YYYY HH:mm:ss"),
        [t("tables.headers.fontSize")]: product.fontSize,
        [t("tables.headers.color")]: product.color,
        [t("tables.headers.course")]: product.dishOrder ? product.dishOrder.description : null,
        [t("tables.headers.openPrice")]: product.freePrice ? t("common.actions.yes") : t("common.actions.no"),
        [t("tables.headers.weighed")]: product.weighed ? t("common.actions.yes") : t("common.actions.no"),
        [t("tables.headers.deleted")]: product.deleted ? t("common.actions.yes") : t("common.actions.no"),
        SPECIAL: product.isSpecial ? t("common.actions.yes") : t("common.actions.no"),
        [t("tables.headers.information")]: product.info,
        [t("tables.headers.deletedAt")]: product.deletedAt ? moment(product.deletedAt).format("DD/MM/YYYY HH:mm:ss") : null,
      };
    });
    return formattedData;
  };

  const handleExportData = async () => {
    try {
      setExcelLoading(true);
      const dataResponse = await apiService.get(`api/v1/products/store/${storeId}`);
      exportToExcel(formatData(dataResponse), `products_${moment().format("YYYYMMDD")}`, t("common.labels.storeProducts"));
      setExcelLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      notificationService.notifyWarn(error.message);
      setExcelLoading(false);
    }
  };

  useEffect(() => {
    if (!storeId) return;
    fetchData();
  }, [storeId, excelData]);

  useEffect(() => {
    if (!storeId) return;
    fetchData();
  }, [forceUpdate]);

  return (
    <>
      {alert}
      <PricelistsPriceModal productId={productId} productName={productName} openModal={openModal} />
      <ProductInventoryModal product={product} openModal={openInventoryModal} parentUpdate={updateTable} />
      <ImportCsvModal type="products" title={t("pages.titles.importProducts")} show={showImport} handleClose={() => setShowImport(false)} onImported={fetchData} />
      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Body>
                <Row className="mx-1">
                  <CreateTableBtn route={"/admin/product"} />
                  <ExportToExcelButton handler={handleExportData} disabled={excelLoading} />
                  <ImportCsvButton handler={() => setShowImport(true)} />
                </Row>
                <Row>
                  <Col>
                    {showLoader ? (
                      <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
                        <ClipLoader size={50} color={"#ff6fbc"} />
                      </div>
                    ) : (
                      <HippoTable data={data} columns={columns} className="-striped -highlight primary-pagination" />
                    )}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ProductListPage;
